import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {
    Box,
    Button, FormControl, Grid, InputAdornment, InputLabel, Select, TextField,
    Typography
} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import AddNewTransaction from "../AddNewTransaction/AddNewTransaction";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {TransactionsService, transactionTypes} from "./TransactionsService";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import searchIcon from "../../assets/images/search-normal.svg";
import {TagService} from "../tagManager/TagService";
import * as React from "react";
import "./Transactions.css"
import DefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/DefaultDialogPage";
import {css} from "@emotion/css";
import filterIcon from "../../assets/images/svg/document-filter.svg"
import {CategoryService} from "../../component/raikoCategory/CategoryService";
import {CategoryParser} from "../../component/raikoCategory/CategoryParser";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {RaikoCustomSelect, raikoCustomSelectItemGenerator} from "@moeindal/base-raiko-panel-components";


let selectedItemId = -1
const CashTransactions = () => {
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TransactionsService(fundID, token, snackbar, loading)
    const tagService = new TagService(fundID, token, snackbar, loading)

    const [tagNameList, setTagNameList] = useState([]);

    const categoryService = new CategoryService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (typeof tagService !== "undefined") {
            tagService.getAllTags()
                .then(response => {
                    setTagNameList(response)
                }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست تگ ها!"))
            })
        }

        if (categoryService) {
            categoryService.getCategoryList()
                .then(response => {
                    setCategoryInlineItems(new CategoryParser(response).getCategoryListInlineParser())
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت اطلاعات دسته بندی ها", snackbar, loading)
            }).finally(_ => {

            })
        }
    }, [])


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])


    const [openModal, setOpenModal] = useState(false)
    const handleClickOpen = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
        selectedItemId = -1

        if (needRefresh) {
            getListDataFromServer()
        }
    }


    const [pageCount, setPageCount] = useState(1);
    const [itemCount, setItemCount] = useState(5);

    const [costsAndRevenuesList, setCostsAndRevenuesList] = useState([]);

    const [needRefresh, setNeedRefresh] = useState(false);

    const [summation, setSummation] = useState("");

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    function getListDataFromServer(
        searchName = transactionName,
        filterStartDate = selectedStartDateFilter,
        filterEndDate = selectedEndDateFilter,
        filterTag = selectedTagFilter,
        filterType = selectedTransactionTypeFilter,
        filterCategory = selectedCategoryId
    ) {
        loading(setLoadingStateDispatch(true))

        service.getCostsAndRevenues(
            page,
            searchName,
            filterStartDate,
            filterEndDate,
            filterTag,
            filterType.id,
            filterCategory
        ).then(({costsAndRevenuesListResponse, constAndRevenuesStatusResponse}) => {

            setResponseData(costsAndRevenuesListResponse)
            setStatusInfo(constAndRevenuesStatusResponse)

            loading(setLoadingStateDispatch(false))
        }).catch(reason => {

            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست هزینه درآمد"))
            loading(setLoadingStateDispatch(false))
        })
    }

    function setStatusInfo(constAndRevenuesStatusResponse) {
        setSummationOfCosts(constAndRevenuesStatusResponse.summationOfCosts)
        setSummationOfRevenues(constAndRevenuesStatusResponse.summationOfRevenues)
        setSummationOfCommissions(constAndRevenuesStatusResponse.summationOfCommissions)
    }

    function setResponseData(responseData) {
        setItemCount(responseData.numberOfItems)
        setPageCount(responseData.totalPage)
        setCostsAndRevenuesList([])
        setSummation(responseData.summationOfAmount)

        responseData.data.map((item, index) => {
            setCostsAndRevenuesList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.amount,
                    item.title,
                    item.description,
                    item.kind,
                    item.payAt ? moment(item.payAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-",
                    item.enabled,
                    item.tag ? item.tag.name : "-",
                    item.categories
                )
            ])
        })
    }

    function prepareGroupsJsonList(id, number, amount, title, description, kind, createdAt, enabled, tag, categories) {
        return {
            id: id,
            number: number,
            title: title,
            tag: tag,
            transaction_type: <div className={"d-flex flex-shrink-1 justifyContentCenter"}>{
                kind === "REVENUES" ? <span
                        className="bg_active_state">+ درآمد</span> :
                    <span
                        className="bg_deActive_state">- هزینه</span>
            }</div>,
            transaction_amount: convertCurrencyFormat(amount),
            date: createdAt,
            enabled: <div className={"d-flex flex-shrink-1 justifyContentCenter"}>
                {enabled === true ? <span
                        className="bg_active_state">فعال</span> :
                    <span
                        className="bg_deActive_state">غیرفعال</span>}
            </div>,
            category: categories && categories.length > 0 ? categories[0].title : "-"
        }
    }

    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setOpenModal(true);
    }

    const [transactionName, setTransactionName] = useState("");

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedTagId, setSelectedTagId] = useState(-1);
    const [transactionTypeFilter, setTransactionTypeFilter] = useState(transactionTypes.ALL);

    const [selectedStartDateFilter, setSelectedStartDateFilter] = useState("");
    const [selectedEndDateFilter, setSelectedEndDateFilter] = useState("");
    const [selectedTagFilter, setSelectedTagFilter] = useState(-1);
    const [selectedTransactionTypeFilter, setSelectedTransactionTypeFilter] = useState(transactionTypes.ALL);

    const [summationOfCosts, setSummationOfCosts] = useState(0);
    const [summationOfRevenues, setSummationOfRevenues] = useState(0);
    const [summationOfCommissions, setSummationOfCommissions] = useState(0);

    const [filterDialogOpenState, setFilterDialogOpenState] = useState(false);

    const [filterTitle, setFilterTitle] = useState("");

    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1)

    function applyFilters() {
        if (checkFilters()) {
            setSelectedStartDateFilter(startDate)
            setSelectedEndDateFilter(endDate)
            setSelectedTransactionTypeFilter(transactionTypeFilter)
            setSelectedTagFilter(selectedTagId)

            getListDataFromServer(
                transactionName,
                startDate,
                endDate,
                selectedTagId,
                transactionTypeFilter,
                selectedCategoryId
            )

            prepareFilterTitles()
            setFilterDialogOpenState(false)
        }
    }

    function checkFilters() {
        let status = false
        let message = ""
        if (startDate.length > 0 && startDate.length !== 10) {
            message = "تاریخ شروع وارد شده صحیح نمی باشد!"
        } else if (endDate.length > 0 && endDate.length !== 10) {
            message = "تاریخ پایان وارد شده صحیح نمی باشد!"
        } else {
            status = true
        }

        if (message.length > 0) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        }

        return status;
    }

    function findCategoryTitle(id) {
        for (let i = 0; i < categoryInlineItems.length; i++) {
            if (parseInt(categoryInlineItems[i].id) === parseInt(id)) {
                return categoryInlineItems[i].name
            }
        }
    }

    function prepareFilterTitles() {
        let _filterTitle = ""
        if (startDate.length > 0) {
            _filterTitle = `از تاریخ ${startDate} ، `
        }
        if (endDate.length > 0) {
            _filterTitle = `${_filterTitle}تا تاریخ ${endDate} ، `
        }
        if (selectedTagId > -1) {
            _filterTitle = `${_filterTitle} تگ ${findTagTitle(selectedTagId)} ، `
        }

        if (selectedCategoryId > -1) {
            _filterTitle = `${_filterTitle} دسته بندی ${findCategoryTitle(selectedCategoryId)} ، `
        }

        if (transactionTypeFilter.type !== transactionTypes.ALL.type) {
            _filterTitle = `${_filterTitle} ${transactionTypeFilter.title} ، `
        }

        if (_filterTitle.length > 0) {
            _filterTitle = `فیلتر ها : ${_filterTitle}`
        }

        setFilterTitle(_filterTitle)
    }

    function findTagTitle(tagId) {
        let _tagName = "نامشخص"

        tagNameList.map(item => {
            if (item.id === tagId) {
                _tagName = item.name;
            }
        })

        return _tagName
    }

    function deleteFilters() {
        setSelectedStartDateFilter("")
        setSelectedEndDateFilter("")
        setSelectedTransactionTypeFilter(transactionTypes.ALL)
        setSelectedTagFilter(-1)

        setStartDate("")
        setEndDate("")
        setTransactionTypeFilter(transactionTypes.ALL)
        setSelectedTagId(-1)

        setSelectedCategoryId(-1)

        getListDataFromServer(
            transactionName,
            "",
            "",
            -1,
            transactionTypes.ALL.id,
            -1
        )

        setFilterDialogOpenState(false)
    }

    return (
        <>
            <DefaultDialogPage
                onClose={_ => setFilterDialogOpenState(false)}
                open={filterDialogOpenState}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"فیلتر ها"}
            >
                <section className={css`display: flex;
                  flex-direction: column;
                  width: 100%;
                  gap: 16px;
                  padding: 0 16px 16px 16px;
                `}>
                    <TextField
                        value={convertToBirthDate(startDate)}
                        onChange={e => {
                            const _date = convertToBirthDate(e.target.value)
                            setStartDate(_date)
                        }}
                        className='w-100'
                        variant="outlined" label="فیلتر تاریخ ابتدا"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <TextField
                        value={convertToBirthDate(endDate)}
                        onChange={e => {
                            const _date = convertToBirthDate(e.target.value)
                            setEndDate(_date)
                        }}
                        className='w-100'
                        variant="outlined" label="فیلتر تاریخ انتها"
                        placeholder="تاریخ مورد نظر را وارد نمایید..."/>

                    <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="filled-age-native-simple">نوع تراکنش</InputLabel>
                        <Select label="نوع تراکنش"
                                value={transactionTypeFilter}
                                onChange={e => {
                                    setTransactionTypeFilter(e.target.value)
                                }}>
                            <option className="p-2" value={transactionTypes.ALL}>همه</option>
                            <option className="p-2" value={transactionTypes.COSTS}>هزینه</option>
                            <option className="p-2" value={transactionTypes.REVENUES}>درآمد</option>
                        </Select>
                    </FormControl>

                    <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="filled-age-native-simple"> تگ</InputLabel>
                        <Select label=" تگ"
                                value={selectedTagId}
                                onChange={e => {
                                    setSelectedTagId(e.target.value)
                                }}>
                            <option className="p-2" value={-1}>همه</option>
                            {tagNameList.map((item, index) => {
                                return <option key={index} className="p-2"
                                               value={item.id}>{item.name}</option>
                            })}
                        </Select>
                    </FormControl>

                    <RaikoCustomSelect
                        items={[
                            raikoCustomSelectItemGenerator(-1, "همه"),
                            ...categoryInlineItems
                        ]}
                        labelText={"دسته بندی"}
                        value={selectedCategoryId}
                        setValue={setSelectedCategoryId}
                    />

                    <section className={css`display: flex;
                      flex-wrap: nowrap;
                      gap: 16px;`}>
                        <Button className={"btn-confirm w-100"} onClick={applyFilters}>اعمال فیلتر</Button>
                        <Button className={"btn-secondary w-100"} onClick={deleteFilters}>پاک کردن</Button>
                    </section>
                </section>
            </DefaultDialogPage>

            <AddNewTransaction
                openModal={openModal}
                handleClickOpen={handleClickOpen}
                handleClose={handleClose}
                selectedItemId={selectedItemId}
                setNeedRefresh={setNeedRefresh}
                tagsList={tagNameList}
            />
            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            دخل و خرج
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " دخل و خرج ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={() => {
                            selectedItemId = -1
                            setOpenModal(true);
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن تراکنش جدید
                    </Button>
                </Box>
                <div className={"transactionStatusContainer hideScroll "}>
                    <div className="transactionStatusItem">
                        <span className={"transactionStatusItemTittle"}>مجموع درآمد ها</span>
                        <span
                            className={"transactionStatusItemAmount"}>{convertCurrencyFormat(summationOfRevenues)}</span>
                        <span className={"transactionStatusItemUnit"}>ریال</span>
                    </div>

                    <div className="transactionStatusItem">
                        <span className={"transactionStatusItemTittle"}>مجموع هزینه ها</span>
                        <span
                            className={"transactionStatusItemAmount"}>{convertCurrencyFormat(summationOfCosts)}</span>
                        <span className={"transactionStatusItemUnit"}>ریال</span>
                    </div>

                    <div className="transactionStatusItem">
                        <span className={"transactionStatusItemTittle"}>مجموع کمیسیون ها</span>
                        <span
                            className={"transactionStatusItemAmount"}>{convertCurrencyFormat(summationOfCommissions)}</span>
                        <span className={"transactionStatusItemUnit"}>ریال</span>
                    </div>
                </div>

                <div className="d-flex">
                    <Grid xs={12} className="d-flex flex-row flex-wrap">
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12}
                              className={css`display: flex;
                                flex-direction: row;
                                flex-wrap: nowrap;
                                gap: 8px;`}>
                            <TextField
                                value={transactionName}
                                onChange={e => {
                                    const _name = e.target.value
                                    setTransactionName(_name)
                                    getListDataFromServer(_name)
                                }}
                                className='w-100'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={searchIcon} alt=""/>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined" label="جستجو بر اساس نام"
                                placeholder="نام تراکنش مورد نظر را وارد نمایید..."/>
                            <section className={css`
                              background: #EBECF1 !important;
                              border-radius: 10px !important;
                              padding: 0 1rem;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              cursor: pointer;
                            `}
                                     onClick={_ => {
                                         setStartDate(selectedStartDateFilter)
                                         setEndDate(selectedEndDateFilter)
                                         setSelectedTagId(selectedTagFilter)
                                         setTransactionTypeFilter(selectedTransactionTypeFilter)

                                         setFilterDialogOpenState(true)
                                     }}
                            >
                                <img src={filterIcon} alt={"filters"}/>
                            </section>
                        </Grid>
                    </Grid>
                </div>
                <span className={css`padding: .5rem 0;
                  font-size: 13px;
                  color: #3F4254;`}>
                    {filterTitle}
                </span>
                <CustomTable
                    header={columns}
                    data={costsAndRevenuesList}
                    rowClicked={showEventsContent}
                    summation={summation}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default CashTransactions;


const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'title',
        label: 'عنوان',
        align: 'right',
    },
    {
        id: 'transaction_type',
        label: 'نوع تراکنش',
        align: 'right',
    },
    {
        id: 'tag',
        label: 'تگ',
        align: 'right',
    },
    {
        id: 'category',
        label: 'دسته بندی',
        align: 'right',
    },
    {
        id: 'transaction_amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
        align: 'right',
    },
];
